import React from "react";

function NeckBeard() {
  return (
    <path
      className="hairMediumShade"
      d="m 253.96222,370.75082 c -50.97383,13.2029 -107.49581,-59.02731 -107.49581,-59.02731 7.14327,46.6913 58.52453,76.62542 88.67536,90.37448 a 53.184411,53.184411 0 0 0 43.90857,0.10402 c 30.49758,-13.7057 82.72841,-43.67451 89.88901,-90.4785 0,0 -57.76165,72.23021 -108.78748,59.02731 a 12.370686,12.370686 0 0 0 -6.18965,0 z"
      id="path183"
    />
  );
}

export default NeckBeard;
